/**
 * Asynchronously loads the component for NotFoundPage
 */

import { lazyLoad } from 'utils/loadable';

export const SyncEntityAreaPage = lazyLoad(
  () => import('./index'),
  module => module.SyncEntityAreaPage
);
